import './vaadin-progress-bar-styles.js';
import '../../src/vaadin-progress-bar.js';
